import MyPageMain from "../../components/MyPage/MyPageMain";

function MyPage() {
  return <MyPageMain />;
}

export default MyPage;
